var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-create-ubl-archive-modal-wrapper",
    {
      on: {
        close: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c(
        "w-card-content",
        [
          !_vm.job
            ? _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [_c("w-progress-circular")],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(
                      " " + _vm._s(_vm.$ct("continue-working-message")) + " "
                    ),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-row", { attrs: { reverse: "" } }, [
                        _vm._v(" " + _vm._s(_vm.job.getStatusMessage()) + " "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-progress-linear", {
                        attrs: { value: _vm.job.getProgressBarValue() },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }